<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 23 14" fill="none">
                    <path
                        d="M15.3293 1H21.6979M21.6979 1V7.36857M21.6979 1L12.7023 9.99561C12.5534 10.1415 12.3534 10.2232 12.145 10.2232C11.9366 10.2232 11.7366 10.1415 11.5878 9.99561L7.92582 6.33368C7.77702 6.18782 7.57695 6.10611 7.36857 6.10611C7.16019 6.10611 6.96012 6.18782 6.81132 6.33368L1 12.145"
                        stroke="#3682F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Endereço de cobrança</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Diatância para localização do IP</div>
                            <div class="item__container--value">{{ distanceToIpLocation }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">IP no pais</div>
                            <div class="item__container--value">{{ isInIpCountry }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Latitude</div>
                            <div class="item__container--value">{{ latitude }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Longitude</div>
                            <div class="item__container--value">{{ longitude }}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableClient',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysis"]
        },
        distanceToIpLocation() {
            return this.data && this.data.risk_body && this.data.risk_body.billing_address && this.data.risk_body.billing_address.distance_to_ip_location ? this.data.risk_body.billing_address.distance_to_ip_location  : '---';
        },
        isInIpCountry() {
            return this.data && this.data.risk_body && this.data.risk_body.billing_address && this.data.risk_body.billing_address.is_in_ip_country ? 'Sim' : 'Não'
        },
        latitude() {
            return this.data && this.data.risk_body && this.data.risk_body.billing_address &&  this.data.risk_body.billing_address.latitude ? this.data.risk_body.billing_address.latitude : '---';
        },
        longitude() {
            return this.data && this.data.risk_body && this.data.risk_body.billing_address && this.data.risk_body.billing_address.longitude ? this.data.risk_body.billing_address.longitude : '---';
        },
        cpf() {
            return this.data && this.data.client && this.data.client.document ? this.data.client.document : '---';
        },
    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>